export default __webpack_public_path__ + "static/media/a011-PPII-3.69200061.svg";